/**
 * DIGITAL OCEAN UPLOADER BASIC SETUP
 **/
import * as AWS from "aws-sdk";

import S3 from "react-aws-s3";
// import { nanoid } from "nanoId";

// console.log(fs);

// const spacesEndpoint = new AWS.Endpoint(
//   process.env.REACT_APP_DO_SPACES_ENDPOINT
// );
const s3 = new AWS.S3({
  endpoint: process.env.REACT_APP_DO_SPACES_ENDPOINT,
  accessKeyId: process.env.REACT_APP_DO_SPACES_KEY,
  secretAccessKey: process.env.REACT_APP_DO_SPACES_SECRET,
});

const config = {
  bucketName: process.env.REACT_APP_DO_BUCKET,
  region: process.env.REACT_APP_DO_SPACES_ENDPOINT,
  accessKeyId: process.env.REACT_APP_DO_SPACES_KEY,
  secretAccessKey: process.env.REACT_APP_DO_SPACES_SECRET,
  s3Url: process.env.REACT_APP_DO_SPACES_URL /* optional */,
};

const client = new S3(config);

export async function uploadFile(file, filename = null) {
  return await client.uploadFile(file, filename ?? file.name);
}
export default s3;
